import { IUpdateTermoEPIUseCase } from "../../../presentation/useCases/update/update_termo_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class UpdateTermoEPIUseCase implements IUpdateTermoEPIUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async execute(
    idTermoEPI: number,
    codigo?: string,
    descricao?: string,
    nome?: string,
    ativo?: boolean
  ): Promise<void> {
    await this.repository.updateTermoEPI(
      idTermoEPI,
      codigo,
      descricao,
      nome,
      ativo
    );
  }

}